import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 16925 16922"
    {...props}
  >
    <defs>
      {/* <style>{".fil0{fill:#000}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2283844313376">
        <g id="Layer_9" data-name="Layer 9">
          <path
            d="M208 3999h2c77 0 151-30 206-85L3498 833c55-55 86-130 86-208 0-163-132-295-295-295-77 0-152 31-208 86L0 3498c55 54 129 85 207 85h1v416zM208 7336h2c77 0 151-31 206-85L6834 833c55-55 86-130 86-208 0-163-131-295-294-295-78 0-153 31-208 86L0 6834c55 55 129 85 207 85h1v417zM208 10666c5 0 10 1 14 1 72 0 141-27 194-74l9761-9760c55-55 86-130 86-208 0-163-132-295-294-295-79 0-154 31-209 86L0 10165c55 54 129 85 207 85h1v416zM208 14003h2c77 0 151-31 206-85L13501 833c55-55 87-130 87-208 0-163-132-295-295-295-78 0-153 31-208 86L0 13501c55 55 129 86 207 86h1v416zM16835 416c-55-55-130-86-208-86-79 0-153 31-208 86L0 16835c55 55 130 87 208 87s153-32 208-87L16835 416c55-55 87-130 87-208s-32-153-87-208v416zM16419 3750 3334 16835c55 55 129 87 208 87 78 0 153-32 208-87L16835 3750c55-55 86-130 86-208 0-163-132-295-294-295-78 0-153 32-208 87v416zM16419 7075l-9761 9760c55 55 130 87 208 87 79 0 154-32 209-87l9760-9749c58-56 90-133 90-214 0-164-133-298-298-298-78 0-153 30-208 84v417zM16419 10417l-6418 6418c55 55 130 87 208 87s153-32 208-87l6418-6418c55-55 86-130 86-208 0-163-132-294-294-294-78 0-153 31-208 86v416zM16419 13754l-3082 3081c55 55 130 87 208 87s154-32 209-87l3081-3081c55-56 86-131 86-209 0-162-132-294-294-294-78 0-153 31-208 86v417z"
            className="fil0"
          />
        </g>
      </g>
    </g>
  </svg>
)
export default SvgComponent
